export default {
  logistics: {
    breadcrumbHome: 'Startseite',
    breadcrumbSolutions: 'Lösungen',
    breadcrumbCurrent: 'Lager & Logistik',
    hero: {
      eyebrow: 'Lager & Logistik',
      title: 'Großflächige Überwachung für Logistik und Lager',
      lead: 'Weitwinkel, PTZ und Nachtsicht – wir decken große Hallen und Außengelände mit wenigen, aber richtig platzierten Kameras ab.',
    },
    areas: {
      title: 'Überwachungsbereiche in Lager und Logistik',
      lead: 'Von der Einfahrt bis zur Verpackung: Wir strukturieren Ihre Überwachung entlang der Warenflüsse – so entstehen keine Lücken.',
      items: {
        '0': { title: 'Ein- & Ausfahrt', desc: 'Jedes Fahrzeug, das Ihr Gelände passiert, wird erfasst – inklusive Kennzeichen und Zeitstempel für lückenlose Dokumentation.' },
        '1': { title: 'Lieferzone', desc: 'Warenanlieferung und -abholung sind sensible Momente. Kameras dokumentieren jeden Handschlag an der Rampe.' },
        '2': { title: 'Regallager', desc: 'Große Hallen brauchen große Lösungen. PTZ-Kameras schwenken über die Gassen und zoomen bei Bedarf bis zur Palette.' },
        '3': { title: 'Kommissionierung', desc: 'Verpackung und Kommissionierung sind geprägt von Bewegung. Überblickskameras schaffen Klarheit bei Reklamationen.' },
        '4': { title: 'Außengelände & Hof', desc: 'Perimeter ist die erste Verteidigungslinie. Wetterfeste Kameras überwachen Zäune, Tore und abgestellte Fahrzeuge.' },
        '5': { title: 'Büro & Verwaltung', desc: 'Auch der administrative Bereich braucht Schutz – für Wertgegenstände, Dokumente und sensible Zugänge.' },
      },
    },
    coverage: {
      eyebrow: 'Großflächig im Blick',
      title: 'Eine Kamera, große Wirkung',
      lead: 'In Lagerhallen zählt der Überblick. Statt vieler einzelner Kameras setzen wir gezielt Technik ein, die große Flächen intelligent abdeckt – und dabei klar kalkulierbar bleibt.',
      items: {
        '0': { title: 'PTZ-Kameras', desc: 'Schwenken, Neigen, Zoomen – eine Kamera deckt große Flächen ab und liefert bei Bedarf Detailaufnahmen.' },
        '1': { title: 'Weitwinkel-Überblick', desc: 'Für Hallenabschnitte und Außenbereiche: kompakte Weitwinkel-Kameras erfassen große Bereiche in einem Bild.' },
        '2': { title: 'Tag- & Nachtsicht', desc: 'Infrarot und hochempfindliche Sensoren liefern auch bei Dunkelheit verwertbare Bilder – rund um die Uhr.' },
      },
    },
    roundClock: {
      eyebrow: 'Rund um die Uhr',
      title: 'Aufzeichnung, die nie schläft',
      lead: 'Warenverkehr hört nachts nicht auf. Ihre Anlage zeichnet rund um die Uhr auf und macht relevante Ereignisse sofort auffindbar.',
      list: {
        '0': '24/7 Aufzeichnung auf lokalem Rekorder mit definierter Speicherdauer',
        '1': 'Ereignisbezogene Aufzeichnung spart Speicher und erleichtert die Suche',
        '2': 'Alarmweiterleitung an definierte Personen bei Bewegung im Sperrbereich',
        '3': 'Regelmäßige Wartung durch SSG Care für dauerhafte Verfügbarkeit',
        '4': 'Erweiterbar um zusätzliche Kameras und weitere Standorte',
      },
      note: 'Hinweis: Die Speicherdauer von Aufzeichnungen sollte an betriebliche und ggf. rechtliche Anforderungen angepasst werden. Wir beraten Sie dazu.',
    },
    cta: {
      title: 'Ihre Logistik – lückenlos dokumentiert',
      lead: 'Wir analysieren Warenflüsse und Gefahrenpunkte und planen ein System, das zu Ihrer Hallenstruktur passt.',
      primary: 'Beratungstermin vereinbaren',
      secondary: 'SSG Care entdecken',
    },
  },
};